import { render, staticRenderFns } from "./CarSize.vue?vue&type=template&id=44bed3b9&"
import script from "./CarSize.vue?vue&type=script&lang=js&"
export * from "./CarSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports